import React from "react";
import { NavBar as DSNav } from "widgets/NavBar";
import { PatientAppPaymentOptionsContext } from "./interfaces";
import { NAV_MENU_V3_ENGAGEMENTS } from "./constants";
import { recordPatientAppClickEngagement } from "../../utils/engagements";

export const PaymentOptionsMenu = ({
    payTotalUrl,
    payPartialUrl,
    paymentPlanCta,
    paymentPlanUrl,
}: PatientAppPaymentOptionsContext) => (
    <DSNav.Menu>
        <DSNav.MenuButton
            onClick={() =>
                recordPatientAppClickEngagement(
                    NAV_MENU_V3_ENGAGEMENTS.PAYMENT_OPTIONS_DROPDOWN_BTN,
                )
            }
        >
            {gettext("Payment options")}
        </DSNav.MenuButton>
        <DSNav.MenuItems>
            {payTotalUrl && (
                <DSNav.MenuItem
                    as="a"
                    href={payTotalUrl}
                    onClick={() =>
                        recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.PAY_TOTAL_BTN)
                    }
                >
                    {gettext("Pay total")}
                </DSNav.MenuItem>
            )}
            {paymentPlanUrl && paymentPlanCta && (
                <DSNav.MenuItem
                    as="a"
                    href={paymentPlanUrl}
                    onClick={() =>
                        recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.PAYMENT_PLAN_BTN)
                    }
                >
                    {paymentPlanCta}
                </DSNav.MenuItem>
            )}
            {payPartialUrl && (
                <DSNav.MenuItem
                    as="a"
                    href={payPartialUrl}
                    onClick={() =>
                        recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.PAY_PARTIAL_BTN)
                    }
                >
                    {gettext("Pay partial")}
                </DSNav.MenuItem>
            )}
        </DSNav.MenuItems>
    </DSNav.Menu>
);
